export default __webpack_public_path__ + "static/media/GitLab-Logo.83df9efb.svg";